import { tokenBp } from '../../../../../shared/token-bp.js';

// Runbook verdict line 9 (cash brake, 2026-11-05): the token only lets cheap items ride along
// with a real offer, so a quote where every item is at the token BP or under it is rejected.
// False until every item has an SP and a BP. Prices in pounds, as on the page.
export function everyItemAtToken(items) {
    const priced = items.filter(it => Number(it.sp) > 0 && it.bp != null && Number.isFinite(Number(it.bp)));
    return priced.length > 0 && priced.length === items.length
        && priced.every(it => Number(it.bp) <= tokenBp(Number(it.sp)));
}
